import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { Router } from '@angular/router'
import { catchError, throwError } from 'rxjs'
import { apiUrl } from '../services/api-url'
import { RetailAuthService } from './state/retail-auth.service'

const RETAIL_API_PREFIX = apiUrl('retail/')

// Attaches the retail session bearer token to retail API requests only, and clears the
// session + routes to /remittance/login on a 401 - but only when the request actually carried
// a bearer token. A 401 on a pre-auth request with no token (e.g. wrong OTP on
// /retail/auth/verify or /retail/auth/register) is a validation error during login, not
// session expiry, so it is rethrown unchanged. Scoped strictly to /api/v3/retail/ URLs so
// it never touches trading-hub (th_session) or other requests - those keep the existing
// authInterceptor. Registered alongside authInterceptor in app.config.ts.
export const retailAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(RETAIL_API_PREFIX)) return next(req)

  const auth = inject(RetailAuthService)
  const router = inject(Router)

  const token = auth.token()
  const tokenAttached = !!token
  const outgoing = token
    ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) })
    : req

  return next(outgoing).pipe(
    catchError(err => {
      if (err.status === 401 && tokenAttached) {
        auth.clearSession()
        router.navigate(['/remittance/login'])
      }
      return throwError(() => err)
    }),
  )
}
